import React from "react";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import FirstPage from "./screen/FirstPage";
import Error from "./screen/Error";
import Category from "./screen/Category";
import Menu from "./screen/Menu";

const App = ({ id }) => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" exact element={<Navigate to="/firstpage" />} />
        <Route path="/firstpage" element={<FirstPage />} />
        <Route path="/category" element={<Category id={id} />} />
        <Route path="/menu" element={<Menu id={id} />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
